export default {
  "5986d9ac4261dc68f5dd403cec97ef5a": "The query failed.",
  "bf8711b086c6f886c938b4ba2b582295": "Failed to select the address",
  "aa413d4c5a5ffc68680171d4a2f96045": "Your address number has exceeded 20. Please edit, modify or delete the original address and then add a new one",
  "2396a131051209fbd19601705f990d1c": "The default address has been modified successfully",
  "852b0aaf2b2fdeae49d4e743a40c3bce": "The default address modification failed",
  "903da4a3d87dbb5d2003b7a574fbd6b4": "The address was deleted successfully.",
  "56091dadb19ab914b66af333835cbc54": "Address deletion failed",
  "abfacaab19409e0b99fec1c75f47bf17": "The order address has been modified successfully",
  "562dae1f882a6098f7a254dadb4313ad": "The order address modification failed",
  "d0a4a1fcdf49f28fb2d51745f1160648": "Click the button",
  "560b5fb04e17fa801b49da28c74ed89c": "Edit",
  "e83de8b6a6e6893f9244634abbae6b87": "You don't have the delivery address yet ~",
  "bbb89af8b403928861ef63b7da6cd2d9": "New addition",
  "76728378c0a571734342f397d7471171": "Delivery address",
  "d7b5325d13c591c3865d1a6bee68c012": "New delivery address added"
}
